/* src/app/components/csvlist/csvlist.component.css */
.selected {
  background-color: var(--navy-500) !important;
  color: white;
}
th {
  text-align: center;
}
.format-spinner {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid var(--border);
  border-top-color: var(--fg-2);
  border-radius: 50%;
  animation: formatSpin 0.7s linear infinite;
  margin-right: 6px;
  vertical-align: middle;
}
@keyframes formatSpin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=csvlist.component.css.map */
